export type ClientThumb = {
    id?: number | string | null;
    name: string | null;
    logo_url?: string | null;
    abbreviation: string;
};

export default function ClientAvatarStack({
    clients,
    maxVisible = 5,
}: {
    clients: ClientThumb[];
    maxVisible?: number;
}) {
    const list = clients.filter((c) => c.name?.trim() || c.id);
    if (!list.length) {
        return null;
    }

    const visible = list.slice(0, maxVisible);
    const hidden = list.slice(maxVisible);
    const remaining = hidden.length;
    const label = (c: ClientThumb) => c.name?.trim() || c.abbreviation;

    return (
        <div className="flex items-center -space-x-2">
            {visible.map((c) => {
                const key = String(c.id ?? c.name ?? c.abbreviation);
                const tip = label(c);
                return c.logo_url ? (
                    <img
                        key={key}
                        src={c.logo_url}
                        alt={tip}
                        title={tip}
                        className="size-6 cursor-pointer rounded-full border-2 border-white object-cover shadow-sm ring-1 ring-gray-200"
                    />
                ) : (
                    <span
                        key={key}
                        title={tip}
                        className="inline-flex size-6 cursor-pointer items-center justify-center rounded-full border-2 border-white bg-primary text-[9px] font-bold text-white shadow-sm ring-1 ring-gray-200"
                    >
                        {c.abbreviation}
                    </span>
                );
            })}
            {remaining > 0 ? (
                <span
                    title={hidden.map(label).join(', ')}
                    className="inline-flex size-6 cursor-pointer items-center justify-center rounded-full border-2 border-white bg-primary-lighter text-[9px] font-bold text-primary-dark ring-1 ring-gray-200"
                >
                    +{remaining}
                </span>
            ) : null}
        </div>
    );
}
